import { render, staticRenderFns } from "./PaymentLinkTab.vue?vue&type=template&id=28f6e051&scoped=true&"
import script from "./PaymentLinkTab.vue?vue&type=script&lang=js&"
export * from "./PaymentLinkTab.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLinkTab.vue?vue&type=style&index=0&id=28f6e051&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6e051",
  null
  
)

export default component.exports